var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('LargeSidebar', {
    attrs: {
      "links": _vm.links,
      "isAdmin": _vm.isAdmin
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "enter-left"
    }
  }, [(_vm.shouldDisplay) ? _c('SmallSidebar', {
    staticClass: "px-2 position-relative",
    attrs: {
      "links": _vm.links,
      "isAdmin": _vm.isAdmin
    }
  }) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7783c681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Layout/Sidebar/SidebarContainer.vue
// module id = BUtO
// module chunks = 2